import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Container } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { submitFeedback } from 'src/apiCalls'; // Ensure the path is correct
import { CAPATCHA_KEY } from 'src/config';
import logger from 'src/logger';
function FeedbackForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        feedbackType: '',
        feedbackText: ''
    });
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCaptchaChange = (value) => {
        setCaptchaVerified(!!value); // Mark as verified if value is truthy
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validate mandatory fields
        if (!formData.name || !formData.email || !formData.feedbackType || !formData.feedbackText) {
            toast.error('Please fill out all required fields.');
            return;
        }

        // // Validate CAPTCHA
        // if (!captchaVerified) {
        //     toast.error('Please complete the CAPTCHA.');
        //     return;
        // }

        try {
            logger.info('Submitting feedback with data:', formData);
            
            // Call submitFeedback with formData
            const response = await submitFeedback(formData);
            logger.info('Feedback submission response:', response);
            
            if (response) {
                toast.success('Thank you for your feedback!');
                
                // Clear form after submission
                setFormData({
                    name: '',
                    email: '',
                    feedbackType: '',
                    feedbackText: ''
                });
                // setCaptchaVerified(false); // Reset CAPTCHA verification
            } else {
                throw new Error('Feedback submission failed - no response received');
            }
        } catch (error) {
            logger.error('Feedback submission error:', error);
            logger.error('Error details:', {
                message: error.message,
                stack: error.stack,
                formData: formData
            });
            toast.error(`Failed to submit feedback: ${error.message}`);
        }
    };

    return (
        <Container component="main" maxWidth="sm">
            <ToastContainer position="bottom-center" />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Feedback Form
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1, mb: 3 }}>
                    We value your feedback! Please share your thoughts, suggestions, or any concerns with us.
                </Typography>
                
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Name"
                        name="name"
                        autoComplete="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="feedbackType"
                        label="Feedback Type (e.g., Suggestion, Complaint)"
                        name="feedbackType"
                        value={formData.feedbackType}
                        onChange={handleChange}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        multiline
                        rows={4}
                        id="feedbackText"
                        label="Your Feedback"
                        name="feedbackText"
                        value={formData.feedbackText}
                        onChange={handleChange}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Submit Feedback
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

export default FeedbackForm;
